// Mock data for Luxury Transfer Service

export const services = [
  {
    id: 1,
    title: "Transfert Simple",
    description: "Transport de point à point avec calcul basé sur distance et durée réelle.",
    icon: "car",
    value: "transfer"
  },
  {
    id: 2,
    title: "Événements d'Entreprise",
    description: "Service professionnel pour réunions, conférences et événements corporate.",
    icon: "briefcase",
    value: "corporate"
  },
  {
    id: 3,
    title: "Réservation par Heure",
    description: "Service flexible à l'heure pour shopping, visites ou trajets multiples (min. 3h).",
    icon: "clock",
    value: "hourly"
  }
];

export const fleet = [
  {
    id: 1,
    name: "Lexus ES300h",
    categoryKey: "executiveSedan",
    badgeKey: "recommended",
    image: "https://scene7.toyota.eu/is/image/toyotaeurope/ES300H_Exploreline-1:Large-Landscape?ts=0&resMode=sharp2&op_usm=1.75,0.3,2,0",
    passengers: 4,
    luggageKey: "standard",
    features: ["Hybrid", "Climate control", "Comfortable seats", "WiFi"],
    basePrice: 110,
    color: "Black",
    isDefault: true
  },
  {
    id: 2,
    name: "Mercedes E-Class",
    categoryKey: "luxurySedan",
    badgeKey: "premium",
    image: "https://carimages.d2cmedia.ca/newcars/cb69aae47fb27ac/Mercedes_Benz/E_Class/2025/MjkxNDg1Xk1lZGlhIEdhbGxlcnk/-duUZWBNR9jhLMEatqu7XsSPxjoTJm4nqLMCAL4Cl2dmesgbfHzdq5ec8vVW1Ri8c0YA1_3MZ5oKdEkWcLPKCEGpX8TlLn1JsmcC0-9xa4bBHxa4F_cbNO9ABYXagYp4n-sTE21U-8aDidlH0ZhylWgJcwwXQdlbil5CstuFa8w-C9u9Q01WD2-xLUR4Um-VPUz6JzeMZ6Q/cc_2025MBC681967207_01_1280_197U.png",
    passengers: 4,
    luggageKey: "standard",
    features: ["Premium sound", "Climate control", "Comfortable seats", "WiFi"],
    basePrice: 110,
    color: "Black",
    isDefault: false
  },
  {
    id: 3,
    name: "BMW Série 5",
    categoryKey: "businessSedan",
    badgeKey: "elegance",
    image: "https://images.unsplash.com/photo-1771396095734-5c79bd6672d5",
    passengers: 4,
    luggageKey: "standard",
    features: ["Premium sound", "Climate control", "Comfortable seats", "WiFi"],
    basePrice: 110,
    color: "Black",
    isDefault: false
  },
  {
    id: 4,
    name: "Mercedes E-Class Break",
    categoryKey: "luxuryEstate",
    badgeKey: "maxLuggage",
    image: "https://cars.caravenuemercedes.be/wp-content/uploads/sites/5/2021/12/Mercedes-Benz-Classe-C-Break-All-Terrain-2021-e1693840103302.png",
    passengers: 4,
    luggageKey: "extended",
    features: ["Extra space", "Premium sound", "Climate control", "WiFi"],
    basePrice: 110,
    color: "Black",
    isDefault: false
  }
];

export const pricingRules = {
  basePrice: 8.0,
  pricePerKm: 1.50,
  pricePerMinute: 0.40
};

export const mockBookings = [
  {
    id: "BK001",
    service: "transfer",
    vehicle: "Lexus ES300h",
    date: "2025-01-15",
    time: "14:30",
    pickup: "Brussels Central Station",
    dropoff: "Brussels Airport",
    distance: 15,
    duration: 25,
    price: 40.5,
    status: "confirmed"
  }
];
